export enum UserRole {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ENTERPRISE_ADMIN = 'ENTERPRISE_ADMIN',
  WORKSITE_ADMIN = 'WORKSITE_ADMIN',
  TEAM_MEMBER = 'TEAM_MEMBER',
}
